import { graphql, useStaticQuery } from 'gatsby';

import Collapsible from 'react-collapsible';
import { Modal } from 'react-bootstrap';
import ModalComponent from './modal';
import React from 'react';
import channels from '../../../channels.json';
import closedIcon from '../../images/icons/collapsible-closed.svg';
import openIcon from '../../images/icons/collapsible-open.svg';
import styled from 'styled-components';
import useIsMobile from '../../hooks/useIsMobile';

const BackgroundWrapper = styled.div`
	background-image: url(${(props) => props.bg});
	box-shadow: 0px 32px 102px rgba(23, 9, 40, 0.36);
	border-radius: 16px;
`;

const DOMAIN = 'https://netsurf.bg/';

const PopupChannels = ({ show, setShow, channelId }) => {
	const data = useStaticQuery(CHANNELS);
	const allData = getChannelsData(channelId);

	return (
		<>
			<ModalComponent show={show} setShow={setShow} dialogClassName="modal-popup">
				<BackgroundWrapper bg={data.bg.childImageSharp.fluid.src}>
					<Modal.Header>
						<Modal.Title id="custom-modal-styling-title" className="w-100">
							<div className="row w-100 d-flex justify-content-end">
								<span
									className="icon popup-close"
									onClick={() => {
										setShow(false);
									}}
								></span>
							</div>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="px-sm-5">
							<p>Виж всички твои</p>
							<h2 className="mb-4">Любими ТВ програми</h2>
						</div>

						{allData.map(({ title, channels }, index) => (
							<ChannelSection
								key={title + index}
								title={title}
								channels={channels}
								isInitiallyOpen={index === 0}
							/>
						))}
					</Modal.Body>
				</BackgroundWrapper>
			</ModalComponent>
		</>
	);
};

const ChannelSection = ({ title, channels, isInitiallyOpen }) => {
	return (
		<>
			<Collapsible
				open={isInitiallyOpen}
				trigger={<CollapsibleHeader isOpen={false} title={title} />}
				triggerWhenOpen={<CollapsibleHeader isOpen={true} title={title} />}
			>
				<ChannelRow channels={channels} title={title} isPopup={true} />
			</Collapsible>
		</>
	);
};

export const ChannelRow = ({ channels, title }) => {
	const isMobile = useIsMobile();

	return (
		<>
			{channels.length > 0 && (
				<div className="row">
					{channels.map((node, index) => {
						return (
							<div
								key={index}
								id={`channel-container-${index}-${title}`}
								className={'p-2 mb-5  justify-content-center'}
								style={{
									width: isMobile ? '50%' : '24%',
									display: 'flex'
								}}
							>
								<img
									width={90}
									height={90}
									src={node}
									alt="Канал"
									onError={(e) => {
										const el = document.getElementById(
											`channel-container-${index}-${title}`
										);
										console.log('el', el);
										if (el) {
											el.style.display = 'none';
											el.style.width = '0';
										}
										e.currentTarget.style.display = 'none';
									}}
								/>
							</div>
						);
					})}
				</div>
			)}
		</>
	);
};

const CollapsibleHeader = ({ title, isOpen }) => {
	return (
		<>
			<div className="row w-100">
				<div className="d-inline-block w-100">
					<button className="clear" type="button">
						<img
							src={isOpen ? openIcon : closedIcon}
							className="d-inline-block"
							alt="Тригър"
						/>
						<h3 className={'d-inline-block pb-0'}>{title}</h3>
					</button>
					<hr className={'ml-5 collapsible channel-popup'} />
				</div>
			</div>
		</>
	);
};

export default PopupChannels;

const getChannelsData = (id) => {
	switch (id) {
		case '75':
			return [
				{
					title: 'Политематични',
					channels: channels.data.channel75.general.files.map((file) => {
						const PATH = 'tv-channels/75/1. Политематични/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Новини',
					channels: channels.data.channel75.news.files.map((file) => {
						const PATH = 'tv-channels/75/2. Новини/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Филми',
					channels: channels.data.channel75.movies.files.map((file) => {
						const PATH = 'tv-channels/75/3. Филми/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Детски',
					channels: channels.data.channel75.kids.files.map((file) => {
						const PATH = 'tv-channels/75/4. Детски/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Спорт',
					channels: channels.data.channel75.sports.files.map((file) => {
						const PATH = 'tv-channels/75/5. Спорт/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Хоби',
					channels: channels.data.channel75.hobbiesAndLifestyle.files.map(
						(file) => {
							const PATH = 'tv-channels/75/6. Хоби Лайфстайл/';
							return `${DOMAIN}${PATH}${file}`;
						}
					)
				},
				{
					title: 'Музика',
					channels: channels.data.channel75.music.files.map((file) => {
						const PATH = 'tv-channels/75/7. Музика/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Документални',
					channels: channels.data.channel75.documentaries.files.map((file) => {
						const PATH = 'tv-channels/75/8. Документални/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: channels.data.channel75.adults18Plus.files.map((file) => {
						const PATH = 'tv-channels/75/9. За възрастни (18+)/';
						return `${DOMAIN}${PATH}${file}`;
					})
				}
			];
		case '110':
			return [
				{
					title: 'Политематични',
					channels: channels.data.channel110.general.files.map((file) => {
						const PATH = 'tv-channels/110/1. Политематични/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Новини',
					channels: channels.data.channel110.news.files.map((file) => {
						const PATH = 'tv-channels/110/2. Новини/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Филми',
					channels: channels.data.channel110.movies.files.map((file) => {
						const PATH = 'tv-channels/110/3. Филми/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Детски',
					channels: channels.data.channel110.kids.files.map((file) => {
						const PATH = 'tv-channels/110/4. Детски/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Спорт',
					channels: channels.data.channel110.sports.files.map((file) => {
						const PATH = 'tv-channels/110/5. Спорт/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Хоби',
					channels: channels.data.channel110.hobbiesAndLifestyle.files.map(
						(file) => {
							const PATH = 'tv-channels/110/6. Хоби Лайфстайл/';
							return `${DOMAIN}${PATH}${file}`;
						}
					)
				},
				{
					title: 'Музика',
					channels: channels.data.channel110.music.files.map((file) => {
						const PATH = 'tv-channels/110/7. Музика/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Документални',
					channels: channels.data.channel110.documentaries.files.map((file) => {
						const PATH = 'tv-channels/110/8. Документални/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: channels.data.channel110.adults18Plus.files.map((file) => {
						const PATH = 'tv-channels/110/9. За възрастни (18+)/';
						return `${DOMAIN}${PATH}${file}`;
					})
				}
			];
		case '170':
			return [
				{
					title: 'Политематични',
					channels: channels.data.channel75.general.files.map((file) => {
						const PATH = 'tv-channels/75/1. Политематични/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Новини',
					channels: channels.data.channel170.news.files.map((file) => {
						const PATH = 'tv-channels/170/2. Новини/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Филми',
					channels: channels.data.channel170.movies.files.map((file) => {
						const PATH = 'tv-channels/170/3. Филми/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Детски',
					channels: channels.data.channel170.kids.files.map((file) => {
						const PATH = 'tv-channels/170/4. Детски/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Спорт',
					channels: channels.data.channel170.sports.files.map((file) => {
						const PATH = 'tv-channels/170/5. Спорт/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Хоби',
					channels: channels.data.channel170.hobbiesAndLifestyle.files.map(
						(file) => {
							const PATH = 'tv-channels/170/6. Хоби Лайфстайл/';
							return `${DOMAIN}${PATH}${file}`;
						}
					)
				},
				{
					title: 'Музика',
					channels: channels.data.channel170.music.files.map((file) => {
						const PATH = 'tv-channels/170/7. Музика/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Документални',
					channels: channels.data.channel170.documentaries.files.map((file) => {
						const PATH = 'tv-channels/170/8. Документални/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: channels.data.channel170.adults18Plus.files.map((file) => {
						const PATH = 'tv-channels/170/9. За възрастни (18+)/';
						return `${DOMAIN}${PATH}${file}`;
					})
				}
			];
		case '200':
			return [
				{
					title: 'Политематични',
					channels: channels.data.channel200.general.files.map((file) => {
						const PATH = 'tv-channels/200/1. Политематични/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Новини',
					channels: channels.data.channel200.news.files.map((file) => {
						const PATH = 'tv-channels/200/2. Новини/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Филми',
					channels: channels.data.channel200.movies.files.map((file) => {
						const PATH = 'tv-channels/200/3. Филми/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Детски',
					channels: channels.data.channel200.kids.files.map((file) => {
						const PATH = 'tv-channels/200/4. Детски/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Спорт',
					channels: channels.data.channel200.sports.files.map((file) => {
						const PATH = 'tv-channels/200/5. Спорт/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Хоби',
					channels: channels.data.channel200.hobbiesAndLifestyle.files.map(
						(file) => {
							const PATH = 'tv-channels/200/6. Хоби Лайфстайл/';
							return `${DOMAIN}${PATH}${file}`;
						}
					)
				},
				{
					title: 'Музика',
					channels: channels.data.channel200.music.files.map((file) => {
						const PATH = 'tv-channels/200/7. Музика/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Документални',
					channels: channels.data.channel200.documentaries.files.map((file) => {
						const PATH = 'tv-channels/200/8. Документални/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: channels.data.channel200.adults18Plus.files.map((file) => {
						const PATH = 'tv-channels/200/9. За възрастни (18+)/';
						return `${DOMAIN}${PATH}${file}`;
					})
				}
			];

		case '200sport':
			return [
				{
					title: 'Политематични',
					channels: channels.data.channel75.general.files.map((file) => {
						const PATH = 'tv-channels/75/1. Политематични/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Новини',
					channels: channels.data.sport200.news.files.map((file) => {
						const PATH = 'tv-channels/200sport/2. Новини/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Филми',
					channels: channels.data.sport200.movies.files.map((file) => {
						const PATH = 'tv-channels/200sport/3. Филми/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Детски',
					channels: channels.data.sport200.kids.files.map((file) => {
						const PATH = 'tv-channels/200sport/4. Детски/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Спорт',
					channels: channels.data.sport200.sports.files.map((file) => {
						const PATH = 'tv-channels/200sport/5. Спорт/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Хоби',
					channels: channels.data.sport200.hobbiesAndLifestyle.files.map(
						(file) => {
							const PATH = 'tv-channels/200sport/6. Хоби Лайфстайл/';
							return `${DOMAIN}${PATH}${file}`;
						}
					)
				},
				{
					title: 'Музика',
					channels: channels.data.sport200.music.files.map((file) => {
						const PATH = 'tv-channels/200sport/7. Музика/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Документални',
					channels: channels.data.sport200.documentaries.files.map((file) => {
						const PATH = 'tv-channels/200sport/8. Документални/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: channels.data.sport200.adults18Plus.files.map((file) => {
						const PATH = 'tv-channels/200sport/9. За възрастни (18+)/';
						return `${DOMAIN}${PATH}${file}`;
					})
				}
			];
		case '200az':
			return [
				{
					title: 'Политематични',
					channels: channels.data.az200.general.files.map((file) => {
						const PATH = 'tv-channels/200az/1. Политематични/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Новини',
					channels: channels.data.az200.news.files.map((file) => {
						const PATH = 'tv-channels/200az/2. Новини/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Филми',
					channels: channels.data.az200.movies.files.map((file) => {
						const PATH = 'tv-channels/200az/3. Филми/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Детски',
					channels: channels.data.az200.kids.files.map((file) => {
						const PATH = 'tv-channels/200az/4. Детски/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Спорт',
					channels: channels.data.az200.sports.files.map((file) => {
						const PATH = 'tv-channels/200az/5. Спорт/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Хоби',
					channels: channels.data.az200.hobbiesAndLifestyle.files.map(
						(file) => {
							const PATH = 'tv-channels/200az/6. Хоби Лайфстайл/';
							return `${DOMAIN}${PATH}${file}`;
						}
					)
				},
				{
					title: 'Музика',
					channels: channels.data.az200.music.files.map((file) => {
						const PATH = 'tv-channels/200az/7. Музика/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Документални',
					channels: channels.data.az200.documentaries.files.map((file) => {
						const PATH = 'tv-channels/200az/8. Документални/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: channels.data.az200.adults18Plus.files.map((file) => {
						const PATH = 'tv-channels/200az/9. За възрастни (18+)/';
						return `${DOMAIN}${PATH}${file}`;
					})
				}
			];
		case '175movie':
			return [
				{
					title: 'Политематични',
					channels: channels.data.channel75.general.files.map((file) => {
						const PATH = 'tv-channels/75/1. Политематични/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Новини',
					channels: channels.data.movie175.news.files.map((file) => {
						const PATH = 'tv-channels/175movie/2. Новини/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Филми',
					channels: channels.data.movie175.movies.files.map((file) => {
						const PATH = 'tv-channels/175movie/3. Филми/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Детски',
					channels: channels.data.movie175.kids.files.map((file) => {
						const PATH = 'tv-channels/175movie/4. Детски/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Спорт',
					channels: channels.data.movie175.sports.files.map((file) => {
						const PATH = 'tv-channels/175movie/5. Спорт/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Хоби',
					channels: channels.data.movie175.hobbiesAndLifestyle.files.map(
						(file) => {
							const PATH = 'tv-channels/175movie/6. Хоби Лайфстайл/';
							return `${DOMAIN}${PATH}${file}`;
						}
					)
				},
				{
					title: 'Музика',
					channels: channels.data.movie175.music.files.map((file) => {
						const PATH = 'tv-channels/175movie/7. Музика/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Документални',
					channels: channels.data.movie175.documentaries.files.map((file) => {
						const PATH = 'tv-channels/175movie/8. Документални/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: channels.data.movie175.adults18Plus.files.map((file) => {
						const PATH = 'tv-channels/175movie/9. За възрастни (18+)/';
						return `${DOMAIN}${PATH}${file}`;
					})
				}
			];
		case '175sport':
			return [
				{
					title: 'Политематични',
					channels: channels.data.sport175.general.files.map((file) => {
						const PATH = 'tv-channels/175sport/1. Политематични/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Новини',
					channels: channels.data.sport175.news.files.map((file) => {
						const PATH = 'tv-channels/175sport/2. Новини/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Филми',
					channels: channels.data.sport175.movies.files.map((file) => {
						const PATH = 'tv-channels/175sport/3. Филми/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Детски',
					channels: channels.data.sport175.kids.files.map((file) => {
						const PATH = 'tv-channels/175sport/4. Детски/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Спорт',
					channels: channels.data.sport175.sports.files.map((file) => {
						const PATH = 'tv-channels/175sport/5. Спорт/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Хоби',
					channels: channels.data.sport175.hobbiesAndLifestyle.files.map(
						(file) => {
							const PATH = 'tv-channels/175sport/6. Хоби Лайфстайл/';
							return `${DOMAIN}${PATH}${file}`;
						}
					)
				},
				{
					title: 'Музика',
					channels: channels.data.sport175.music.files.map((file) => {
						const PATH = 'tv-channels/175sport/7. Музика/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Документални',
					channels: channels.data.sport175.documentaries.files.map((file) => {
						const PATH = 'tv-channels/175sport/8. Документални/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: channels.data.sport175.adults18Plus.files.map((file) => {
						const PATH = 'tv-channels/175sport/9. За възрастни (18+)/';
						return `${DOMAIN}${PATH}${file}`;
					})
				}
			];

		default:
			return [
				{
					title: 'Политематични',
					channels: channels.data.az200.general.files.map((file) => {
						const PATH = 'tv-channels/200az/1. Политематични/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Новини',
					channels: channels.data.az200.news.files.map((file) => {
						const PATH = 'tv-channels/200az/2. Новини/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Филми',
					channels: channels.data.az200.movies.files.map((file) => {
						const PATH = 'tv-channels/200az/3. Филми/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Детски',
					channels: channels.data.az200.kids.files.map((file) => {
						const PATH = 'tv-channels/200az/4. Детски/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Спорт',
					channels: channels.data.az200.sports.files.map((file) => {
						const PATH = 'tv-channels/200az/5. Спорт/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Хоби',
					channels: channels.data.az200.hobbiesAndLifestyle.files.map(
						(file) => {
							const PATH = 'tv-channels/200az/6. Хоби Лайфстайл/';
							return `${DOMAIN}${PATH}${file}`;
						}
					)
				},
				{
					title: 'Музика',
					channels: channels.data.az200.music.files.map((file) => {
						const PATH = 'tv-channels/200az/7. Музика/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'Документални',
					channels: channels.data.az200.documentaries.files.map((file) => {
						const PATH = 'tv-channels/200az/8. Документални/';
						return `${DOMAIN}${PATH}${file}`;
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: channels.data.az200.adults18Plus.files.map((file) => {
						const PATH = 'tv-channels/200az/9. За възрастни (18+)/';
						return `${DOMAIN}${PATH}${file}`;
					})
				}
			];
	}
};

const CHANNELS = graphql`
	query Channles {
		bg: file(relativePath: { eq: "popup-channels-bg.png" }) {
			childImageSharp {
				fluid(maxWidth: 2000) {
					src
				}
			}
		}
	}
`;

